namespace Portico.Models.Enterprise {
	export interface IUserProfile {
		id: number;
		secureId: string;
		firstName: string;
		lastName: string;
		email: string;
		roles: UserProfileRole[];

		getRole(name: string);
	}

	export class UserProfile implements IUserProfile {
		id: number;
		secureId: string;
		firstName: string;
		lastName: string;
		email: string;
		roles: UserProfileRole[];

		constructor(obj?: IUserProfile) {
			this.id = null;
			this.secureId = null;
			this.firstName = ''
			this.lastName = '';
			this.email = '';
			this.roles = [];

			if (obj) {
				this.id = obj.id || null;
				this.secureId = obj.secureId || null;
				this.firstName = obj.firstName || '';
				this.lastName = obj.lastName || '';
				this.email = obj.email || '';

				if (obj.roles) {
					for (const role of obj.roles) {
						this.roles.push(new UserProfileRole(role));
					}
				}
            }
		}

		getRole(name: string) {
			return _.find(this.roles, (role) => {
				return role.name === name;
			});
		}
	}

	export interface IUserProfileRole {
		name: string;
		permissions: UserProfilePermission[];
	}

	export class UserProfileRole implements IUserProfileRole {
		name: string;
		permissions: UserProfilePermission[];

		constructor(obj?: IUserProfileRole) {
			this.name = '';
			this.permissions = [];

			if (obj) {
				this.name = obj.name || '';

				if (obj.permissions) {
					for (const permission of obj.permissions) {
						this.permissions.push(new UserProfilePermission(permission));
					}
				}
			}
		}
	}

	export interface IUserProfilePermission {
		name: string;
	}

	export class UserProfilePermission implements IUserProfilePermission {
		name: string;

		constructor(obj?: IUserProfilePermission) {
			this.name = '';

			if (obj) {
				this.name = obj.name || '';
			}
		}
	}
}
